import { styled } from "@mui/material";

export const Main = styled("main")({
  backgroundColor: "#FAFBFE",
  flex: 1,
  minHeight: 0,
  minWidth: 0,
  position: "relative",
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
});
